<template>
  <section class="uploadArea">
    <div id="uploadCircle" class="clip-circle toppageCircle">
      <p class="upload_text">{{calculatedCurrentBytes}}MB / {{calculatedTotalBytes}}MB</p>
    </div>
  </section>
</template>

<script>
const MEGA_BYTES = 1048576;
const MAX_FILE_DECIMAL = 2;
const DECINAL_MAGNIFICATION = Math.pow(10, MAX_FILE_DECIMAL);
const AUDIO_FILE = "/sound.wav";
// const UPLOAD_URL = '/upload';
const UPLOAD_URL = 'https://filepassport.jp/upload';
// const UPLOAD_URL = 'http://localhost:8080/upload';
const axios = require('axios');

export default {
  props: ['uploadFile'],
  data: function(){
    return {
      totalBytes: 0,
      currentBytes: 0
    }
  },
  computed: {
    calculatedTotalBytes: function(){
      return Math.floor( this.totalBytes / MEGA_BYTES * DECINAL_MAGNIFICATION ) / DECINAL_MAGNIFICATION;
    },
    calculatedCurrentBytes: function(){
      return Math.floor( this.currentBytes / MEGA_BYTES * DECINAL_MAGNIFICATION ) / DECINAL_MAGNIFICATION;
    }
  },
  mounted: function() {

    // let sound = new Audio("data:audio/wav;base64," + AUDIO_FILE);
    // 音を再生
    let sound = document.getElementById('audio');
    sound.currentTime = 0;

    // ファイルの合計サイズを設定
    this.totalBytes = this.uploadFile.size;

    // フォームデータを作成
    let _formdata = new FormData();
    _formdata.append('uploadfile', this.uploadFile);

    var bar = new ProgressBar.Circle("#uploadCircle", {
      color: "#4c4b4a",
      strokeWidth: 1.5,
      trailWidth: 1.5,
      easing: "easeInOut",
      duration: 500,
      text: {
        autoStyleContainer: false
      },
      from: { color: "#9f9f9a", width: 1.5 },
      to: { color: "#53524d", width: 1.5 },
      step: (state, circle) => {
        circle.path.setAttribute("stroke", state.color);
        circle.path.setAttribute("stroke-width", state.width);

        let value = Math.round(circle.value() * 100);
        if (value === 0) {
          circle.setText("0");
        } else {
          circle.setText(value);
        }

        // if(value == 100){
        //   // 完了画面に移動
        //   this.$router.push('complete');
        // }
      }
    });

    // 詳細設定
    let _config = {
      header: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        this.currentBytes = progressEvent.loaded;
        bar.animate(percentCompleted / 100);
      }
    };

    // ファイルをアップロードする
    axios.post(UPLOAD_URL, _formdata, _config).then(response => {
      // 日付を取得
      let _now = new Date();

      // ファイル情報を保存
      this.$store.dispatch('FILE_UPLOAD_START', {
        name: this.uploadFile.name,
        size: Math.floor( this.uploadFile.size / MEGA_BYTES * DECINAL_MAGNIFICATION ) / DECINAL_MAGNIFICATION,
        date: `${_now.getFullYear()}.${_now.getMonth()+1}.${_now.getDate()} ${_now.getHours()}:${_now.getMinutes()}`,
        download_url: response['data'][0]['url'],
        download_password: response['data'][0]['password'],
        download_times: response['data'][0]['times'],
        download_expires: response['data'][0]['expires'],
        download_expires_date: response['data'][0]['expiresdate'],
      });

      sound.play();
      sound.onended = () => {     
          // サーバーからのレスポンスを保存
          this.$store.dispatch('FILE_UPLOAD_COMPLETED', response);

          // 完了画面に移動
          this.$router.push('complete');
      };

    });


    // bar.animate(1.0);
  }
};

</script>

<style scoped lang="scss"></style>
